module.exports = __webpack_public_path__ + "static/media/uvbot.efac7217.png";